/**
 * Income calculator
 * @param settlements - settlements prices Array
 * @param peopleCount - people count
 */

export function calcProfitIncome(settlements: number[], peopleCount: number): number {
  if (peopleCount <= 0 || settlements.length === 0) return 0;

  const totalSettlementPrice = settlements.reduce((sum, price) => sum + price, 0);

  const firstGroup = Math.min(peopleCount, 4) * 0.67 * totalSettlementPrice;
  const secondGroup = Math.max(peopleCount - 4, 0) * 0.33 * totalSettlementPrice;

  return firstGroup + secondGroup;
}
